import { miscSearch } from '../../utils/api/ngx_api';
import BaseAPI from '../../utils/api/base_api';
import {
    SET_CURRENT_QUESTIONNAIRE,
    SET_CURRENT_VENDOR,
    GET_SERVICES_QUESTIONNAIRES,
    GET_VENDOR_COMPLETION_INFO,
    GET_VENDOR_LIST,
    GET_VENDOR_QUESTIONNAIRES_RESPONSE,
    DISPLAY_VENDOR_QUESTIONNAIRES_RESPONSE,
    GET_PACKAGES,
    GET_QUESTIONNAIRE_CATEGORIES,
    GET_QUESTIONNAIRE_SUBCATEGORIES,
    GET_CURRENT_SCM_QUESTIONNARE_SUMMARY_DATA,
    GET_CATEGORY_COMPLETION_FOR_USER,
    GET_CURRENT_VENDOR_INFO,
    GET_SECONDARY_SCM_QUESTIONNARY_SUMMARY_DATA,
    QUESTIONNAIRE_LIST_LOADED,
    QUESTIONNAIRE_SUMMARY_LOADED_ALL_VENDORS,
    QUESTIONNIARE_SUMMARIES_LOADED_VENDOR,
    CATEGORY_SUMMARY_LOADED_VENDOR,
    VENDOR_INFO_LOADED,
    SUPPLY_CHAIN_CATEGORY_SUMMARY_LOADED,
    SUPPLY_CHAIN_CATEGORY_QUESTIONS_LOADED,
    SET_CURRRENT_SUPPLY_CHAIN_CATEGORY,
    SET_REPORT_MANAGEMENT_SUMMARY_TYPE,
} from './types';
import { sortCategoryByName, sortCompaniesByName } from './utils';

import { getCurrentUserSummaries } from '../profile/actions';
import {
    categorySummaryQuestionsSucceded,
    categorySummaryQuestionsFailed,
    requestCategorySummaryQuestions,
} from '../ui/actions';

/****************************
 * New action creators
 *****/

// Setters

export const setCurrentQuestionnaire = (payload) => {
    return { type: SET_CURRENT_QUESTIONNAIRE, payload };
};

export const setCurrentVendor = (payload) => {
    return { type: SET_CURRENT_VENDOR, payload };
};

export const setSupplyChainCategory = (payload) => {
    return { type: SET_CURRRENT_SUPPLY_CHAIN_CATEGORY, payload };
};

export const setReportManagementSummaryType = (payload) => {
    return { type: SET_REPORT_MANAGEMENT_SUMMARY_TYPE, payload };
};

// Getters
export const loadQuestionnaireList = (payload) => {
    return { type: QUESTIONNAIRE_LIST_LOADED, payload };
};

export const loadQuestionnaireSummaryAllVendors = (payload) => {
    return {
        type: QUESTIONNAIRE_SUMMARY_LOADED_ALL_VENDORS,
        payload: sortCompaniesByName(payload),
    };
};

export const loadQuestionnaireSummariesVendor = (payload) => {
    return { type: QUESTIONNIARE_SUMMARIES_LOADED_VENDOR, payload };
};

export const loadCategorySummaryVendor = (payload) => {
    return {
        type: CATEGORY_SUMMARY_LOADED_VENDOR,
        payload: sortCategoryByName(payload),
    };
};

export const loadVendorInfo = (payload) => {
    return { type: VENDOR_INFO_LOADED, payload };
};

export const loadSupplyChainCategorySummary = (payload) => {
    return { type: SUPPLY_CHAIN_CATEGORY_SUMMARY_LOADED, payload };
};

export const loadSupplyChainCategoryQuestions = (payload) => {
    return { type: SUPPLY_CHAIN_CATEGORY_QUESTIONS_LOADED, payload };
};

/****************************
 * Legacy action creators
 *****/
export const getVendorCompletionInfo = (payload) => {
    return { type: GET_VENDOR_COMPLETION_INFO, payload };
};

export const getVendorList = (payload) => {
    return { type: GET_VENDOR_LIST, payload };
};

export const getServicesQuestionnaires = (payload) => {
    return { type: GET_SERVICES_QUESTIONNAIRES, payload };
};

export const getVendorQuestionnairesResponse = (payload) => {
    return { type: GET_VENDOR_QUESTIONNAIRES_RESPONSE, payload };
};

export const displayVendorQuestionnairesResponse = (payload) => {
    return { type: DISPLAY_VENDOR_QUESTIONNAIRES_RESPONSE, payload };
};

export const getPackages = (payload) => {
    return { type: GET_PACKAGES, payload };
};

export const getQuestionnaireCategories = (payload) => {
    return { type: GET_QUESTIONNAIRE_CATEGORIES, payload };
};

export const getQuestionnaireSubcategories = (payload) => {
    return { type: GET_QUESTIONNAIRE_SUBCATEGORIES, payload };
};

export const getCurrentSCMQuestionnaireSummary = (payload) => {
    return { type: GET_CURRENT_SCM_QUESTIONNARE_SUMMARY_DATA, payload };
};

export const getSecondarySCMQuestionnairesSummary = (payload) => {
    return { type: GET_SECONDARY_SCM_QUESTIONNARY_SUMMARY_DATA, payload };
};

export const getCategoryCompletionForUser = (payload) => {
    return { type: GET_CATEGORY_COMPLETION_FOR_USER, payload };
};

export const getCurrentVendorInfo = (payload) => {
    return { type: GET_CURRENT_VENDOR_INFO, payload };
};

/****************************
 * More complex action creators
 * **********
 * **********
 ************/

/****************************
 * New action creators
 ************/

// When we reach the app entry point, this will make sure that we have some sort of default values to fill
// out our Third Party Risk Management pages
export const firstLoad = () => async (dispatch) => {
    // Get a list of all of our questionnaires
    const questList = await BaseAPI.get('/qns')
        .then((response) => {
            dispatch(loadQuestionnaireList(response.data));
            return response.data;
        })
        .catch((error) => console.error('error in qns', error));

    // const { id } = questList[0];
    //!! CURRENTLY HARD CODING THIS SO WE DON'T GET BACK COMPLIANCE ASSESSMENT
    const id = 'cjgzXxU1AzWdPeA4GVdY';

    dispatch(setCurrentQuestionnaire(id));

    // Get a summary for this questionnaires for each of our vendors
    BaseAPI.get('/ans/vendorSummary', {
        params: { questionnaire_id: id || '' },
    })
        .then(({ data }) => {
            // This will give us a questionnaire summary for all vendors
            const filteredData = data.filter((object) => object !== null);
            dispatch(loadQuestionnaireSummaryAllVendors(filteredData));

            // This will give us a questionnaire summary for a single vendor and set our current vendor
            if (data.length) {
                dispatch(loadVendorInfo(data[0] || {}));
                dispatch(setCurrentVendor(data[0].company_id || ''));
                BaseAPI.get('/ans/vendorSummary', {
                    params: {
                        // questionnaire_id: id,
                        vendor_company_id: data[0].company_id,
                    },
                })
                    .then((response) =>
                        // This will set all the summaries for the currently selected vendor
                        dispatch(
                            loadQuestionnaireSummariesVendor(response.data[0])
                        )
                    )
                    .catch((error) => console.error(error));
                BaseAPI.get('/ans/vendorCategoryTotal', {
                    params: {
                        questionnaire_id: id,
                        vendor_company_id: data[0].company_id || '',
                    },
                })
                    .then((response) => {
                        dispatch(loadCategorySummaryVendor(response.data));
                    })
                    .catch((error) => console.error(error));
            }
        })
        .catch((error) => console.error(error));

    // Gets us our category summary for the entire Third Party Risk Management
    BaseAPI.get('/ans/vendorCategoryTotal', {
        params: { questionnaire_id: id },
    })
        .then((response) => {
            dispatch(loadSupplyChainCategorySummary(response.data));
        })
        .catch((error) => console.error(error));
};

// This will gives us a summary for every questionnaire assigned to a particular vendor
// and all categories for the current questionnaire
export const changeVendor = (vendorId) => async (dispatch, getState) => {
    const state = getState();
    const { _currentQuestionnaire } = state.vendorReducer;
    // Set our current vendor
    dispatch(setCurrentVendor(vendorId));

    // Get a set of categories for our current vendor
    BaseAPI.get('/ans/vendorCategoryTotal', {
        params: {
            questionnaire_id: state.vendorReducer._currentQuestionnaire,
            vendor_company_id: vendorId,
        },
    })
        .then((response) => {
            dispatch(loadCategorySummaryVendor(response.data));
        })
        .catch((error) => console.error(error));

    // Get all questionnaires in a summary for the current vendor
    BaseAPI.get('/ans/vendorSummary', {
        params: {
            vendor_company_id: vendorId,
        },
    })
        .then((response) => {
            // This will set all the summaries for the currently selected vendor
            dispatch(loadQuestionnaireSummariesVendor(response.data[0]));
            const filteredSummary = response.data[0].filter((questionnaire) => {
                return questionnaire.questionnaire_id === _currentQuestionnaire;
            });

            dispatch(loadVendorInfo(filteredSummary[0] || [{}]));
        })
        .catch((error) => console.error(error));
};

export const changeQuestionnaire =
    (questionnaireId) => async (dispatch, getState) => {
        const state = getState();
        // Set the current questionnaire
        dispatch(setCurrentQuestionnaire(questionnaireId));

        // Get the current vendor
        const { _currentVendor } = state.vendorReducer;

        // Change the category summary using the current vendor
        BaseAPI.get('/ans/vendorCategoryTotal', {
            params: {
                questionnaire_id: questionnaireId,
                vendor_company_id: _currentVendor,
            },
        })
            .then((response) => {
                dispatch(loadCategorySummaryVendor(response.data));
            })
            .catch((error) => console.error(error));

        // Change all the summaries using the current vendor

        BaseAPI.get('/ans/vendorSummary', {
            params: { questionnaire_id: questionnaireId },
        })
            .then((response) => {
                const filteredData = response.data.filter(
                    (object) => object !== null
                );

                const filteredSummary = filteredData.filter((questionnaire) => {
                    return questionnaire.company_id === _currentVendor;
                });

                dispatch(loadVendorInfo(filteredSummary[0]));
                dispatch(loadQuestionnaireSummaryAllVendors(filteredData));
            })
            .catch((error) => console.log('error: ', error));
    };

/****************************
 * Third Party Risk Management OVERVIEW
 *
 * This is used for a general overview of the entire Third Party Risk Management.
 ************/

// Loads the overall totals for all categories in this questionnaire
export const changeSupplyChainCategoryOverview =
    (questionnaireId) => async (dispatch) => {
        // If we are going to change our Third Party Risk Management category overview, we are going to also
        // going to need to change the current questions that we are looking at in the
        dispatch(setCurrentQuestionnaire(questionnaireId));
        BaseAPI.get('/ans/vendorCategoryTotal', {
            params: { questionnaire_id: questionnaireId },
        })
            .then((response) => {
                // Get the first category from this response
                // Do a call to the question total

                const { category } = response.data[0];

                BaseAPI.get('/ans/vendorQuestionTotal', {
                    params: { questionnaire_id: questionnaireId, category },
                })
                    .then((response) => {
                        dispatch(
                            loadSupplyChainCategoryQuestions(response.data)
                        );
                    })
                    .catch((error) => console.error(error));

                dispatch(loadSupplyChainCategorySummary(response.data));
            })
            .catch((error) => console.error(error));
    };

// Loads the overall totals for a category on the current questionnaire
export const changeSupplyChainCategoryQuestions =
    (category) => async (dispatch, getState) => {
        dispatch(requestCategorySummaryQuestions());
        const state = getState();

        const { _currentQuestionnaire } = state.vendorReducer;

        // Get a specific category's summaries
        BaseAPI.get('/ans/vendorQuestionTotal', {
            params: { questionnaire_id: _currentQuestionnaire, category },
        })
            .then((response) => {
                dispatch(categorySummaryQuestionsSucceded());
                dispatch(loadSupplyChainCategoryQuestions(response.data));
            })
            .catch((error) => {
                dispatch(categorySummaryQuestionsFailed());
                console.error(error);
            });
    };

/****************************
 * Legacy action creators
 ************/

export const getPackageData = () => async (dispatch) => {
    BaseAPI.get('/vox_packages', {})
        .then((response) => {
            dispatch(getPackages(response.data));
        })
        .catch((error) => console.log('error: ', error));
};

export const getQuestionnaireCategoriesData = () => async (dispatch) => {
    BaseAPI.get('/questionnaire_categories').then(({ data }) =>
        dispatch(getQuestionnaireCategories(data))
    );
};

export const getQuestionnaireSubcategoriesData = () => async (dispatch) => {
    BaseAPI.get('/questionnaire_subcategories').then(({ data }) =>
        dispatch(getQuestionnaireSubcategories(data))
    );
};

export const getCategoriesAndSubCategoriesData = () => async (dispatch) => {
    dispatch(getQuestionnaireCategoriesData());
    dispatch(getQuestionnaireSubcategoriesData());
};

export const setCurrentSummary =
    (questionnaireId, vendorId) => async (dispatch) => {
        // Make an API call with the package id and get the summary for all

        if (vendorId) {
            // 	Set the currentVendorInfo as the first one of those packages
            // 	Set the category info as the first vendor of those packages

            BaseAPI.get('/ans/vendorSummary', {
                params: { questionnaire_id: questionnaireId },
            })
                .then((response) => {
                    const { data } = response;
                    const filteredData = data.filter(
                        (object) => object !== null
                    );
                    dispatch(
                        getCurrentSCMQuestionnaireSummary(
                            filteredData.filter(
                                (summary) => summary.company_id === vendorId
                            )
                        )
                    );
                    dispatch(getCurrentVendorInfo(filteredData[0]));
                    BaseAPI.get('/ans/vendorCategoryTotal', {
                        params: {
                            questionnaire_id: questionnaireId,
                            vendor_company_id: vendorId,
                        },
                    })
                        .then(({ data }) => {
                            const filteredData = data.filter(
                                (object) => object !== null
                            );
                            dispatch(
                                getCategoryCompletionForUser(filteredData)
                            );
                        })
                        .catch((error) =>
                            console.log('error in summary: ', error)
                        );
                })
                .catch((error) => console.log('error in summary: ', error));
        } else {
            // 	Set the currentVendorInfo as the first one of those packages
            // 	Set the category info as the user id for the first one of those packages
            BaseAPI.get('/ans/vendorSummary', {
                params: { questionnaire_id: questionnaireId },
            })
                .then((response) => {
                    const { data } = response;
                    const filteredData = data.filter(
                        (object) => object !== null
                    );
                    dispatch(getCurrentSCMQuestionnaireSummary(filteredData));
                    dispatch(getCurrentVendorInfo(filteredData[0]));
                    BaseAPI.get('/ans/vendorCategoryTotal', {
                        params: {
                            questionnaire_id: questionnaireId,
                            vendor_company_id: vendorId,
                        },
                    })
                        .then(({ data }) => {
                            const filteredData = data.filter(
                                (object) => object !== null
                            );
                            dispatch(
                                getCategoryCompletionForUser(filteredData)
                            );
                        })
                        .catch((error) =>
                            console.log('error in summary: ', error)
                        );
                })
                .catch((error) => console.log('error in summary: ', error));
        }
    };

/*****
 * Get high level overview of a particular package owned by the vendor
 */
export const getCurrentQuestionnaireSummaryAll =
    (questionnaireId) => async (dispatch, getState) => {
        // Make an call and get all the info for that particular questionnaire

        BaseAPI.get('/ans/vendorSummary', {
            params: { questionnaire_id: questionnaireId },
        })
            .then((response) => {
                const { data } = response;
                const filteredData = data.filter((object) => object !== null);
                dispatch(getCurrentSCMQuestionnaireSummary(filteredData));
                dispatch(getCurrentVendorInfo(filteredData[0]));
            })
            .catch((error) =>
                console.log(
                    'error in getCurrentQuestionnaireSummaryAll: ',
                    error
                )
            );

        // Write it to the store
    };

export const getSecondaryQuestionnaireSummaryAll =
    (questionnaireId) => async (dispatch, getState) => {
        // Make an call and get all the info for that particular questionnaire
        BaseAPI.get('/ans/vendorSummary', {
            params: { questionnaire_id: questionnaireId },
        })
            .then((response) => {
                const { data } = response;
                const filteredData = data.filter((object) => object !== null);
                dispatch(getSecondarySCMQuestionnairesSummary(filteredData));
                // dispatch(getCurrentVendorInfo(filteredData[0]));
            })
            .catch((error) =>
                console.log(
                    'error in getCurrentQuestionnaireSummaryAll: ',
                    error
                )
            );

        // Write it to the store
    };

/****
 * Get a category summary for a particular user
 */
export const getCategoryTotalsForPackage =
    (vendorId, questionnaireId) => async (dispatch, getState) => {
        const state = getState();

        let companyId = vendorId;

        if (!companyId) {
            companyId = state.vendorReducer.currentCompany;
        }
        // If we are not passing in a vendor ID, grab from state

        // Make an api call using vendorId and questionnaireId params
        dispatch(setCurrentVendor(companyId));

        await BaseAPI.get('/ans/vendorCategoryTotal', {
            params: {
                questionnaire_id: questionnaireId,
                vendor_company_id: companyId,
            },
        })
            .then(({ data }) => {
                const filteredData = data.filter((object) => object !== null);
                dispatch(getCategoryCompletionForUser(filteredData));

                BaseAPI.get('/ans/vendorSummary', {
                    params: { questionnaire_id: questionnaireId },
                })
                    .then(({ data }) => {
                        const filteredData = data
                            .filter((object) => object !== null)
                            .filter(
                                (object) => object.company_id === companyId
                            );

                        dispatch(getCurrentVendorInfo(filteredData[0]));
                    })
                    .catch((error) =>
                        console.log(
                            'error in getCurrentQuestionnaireSummaryAll: ',
                            error
                        )
                    );
            })
            .catch((error) =>
                console.log(
                    'error in getCurrentQuestionnaireSummaryAll: ',
                    error
                )
            );
    };



// WEBPACK FOOTER //
// ./src/redux/vendor/actions.js